import banner1 from '../Images/header-banner1.jpg'
import banner2 from '../Images/header-banner4.jpg'
import banner3 from '../Images/slide_offer1.jpg'
import course from '../Images/7.png'

export const images = [
    {
        src:banner1
    },
    {
        src:banner2
    },
    {
        src:banner3
    }
]

export const features = [
    {
        src:course,
        price:"2000",
        name : "Subject 1"
    },
    {
        src:course,
        price:"2000",
        name : "Subject 2"
    },
    {
        src:course,
        price:"2000",
        name : "Subject 3"
    },
    {
        src:course,
        price:"2000",
        name : "Subject 4"
    },
    {
        src:course,
        price:"2000",
        name : "Subject 5"
    },
    {
        src:course,
        price:"2000",
        name : "Subject 6"
    },
    {
        src:course,
        price:"2000",
        name : "Subject 7"
    }
]

export const enroll = [
    {
        src:course,
        topic:"Education (NET/SET)"
    },
    {
        src:course,
        topic:"Education (NET/SET)"
    },
    {
        src:course,
        topic:"Education (NET/SET)"
    },
    {
        src:course,
        topic:"Education (NET/SET)"
    },
    {
        src:course,
        topic:"Education (NET/SET)"
    },
    {
        src:course,
        topic:"Education (NET/SET)"
    }
]

export const courses = [
    {
        src:course,
        topic:"NET & SET 1",
        full_course:[
            {
                src:course,
                name:"NET & SET 1.1",
                price:3999,
                topic:[
                    {
                        src:course,
                        head:"Teaching Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    },
                    {
                        src:course,
                        head:"Reseaching and Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    },
                    {
                        src:course,
                        head:"Teaching Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    },
                    {
                        src:course,
                        head:"Reseaching and Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    },
                    {
                        src:course,
                        head:"Teaching Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    },
                    {
                        src:course,
                        head:"Reseaching and Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    }
                ]
            },
            {
                src:course,
                name:"NET & SET 1.2",
                price:3999,
                topic:[
                    {
                        src:course,
                        head:"Teaching Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    },
                    {
                        src:course,
                        head:"Reseaching and Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    },
                    {
                        src:course,
                        head:"Teaching Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    },
                    {
                        src:course,
                        head:"Reseaching and Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    },
                    {
                        src:course,
                        head:"Teaching Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    },
                    {
                        src:course,
                        head:"Reseaching and Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    }
                ]
            },
            {
                src:course,
                name:"NET & SET 1.3",
                price:3999,
                topic:[
                    {
                        src:course,
                        head:"Teaching Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    },
                    {
                        src:course,
                        head:"Reseaching and Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    },
                    {
                        src:course,
                        head:"Teaching Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    },
                    {
                        src:course,
                        head:"Reseaching and Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    },
                    {
                        src:course,
                        head:"Teaching Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    },
                    {
                        src:course,
                        head:"Reseaching and Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    }
                ]
            },
            {
                src:course,
                name:"NET & SET 1.4",
                price:3999,
                topic:[
                    {
                        src:course,
                        head:"Teaching Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    },
                    {
                        src:course,
                        head:"Reseaching and Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    },
                    {
                        src:course,
                        head:"Teaching Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    },
                    {
                        src:course,
                        head:"Reseaching and Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    },
                    {
                        src:course,
                        head:"Teaching Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    },
                    {
                        src:course,
                        head:"Reseaching and Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    }
                ]
            },
            {
                src:course,
                name:"NET & SET 1.5",
                price:3999,
                topic:[
                    {
                        src:course,
                        head:"Teaching Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    },
                    {
                        src:course,
                        head:"Reseaching and Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    },
                    {
                        src:course,
                        head:"Teaching Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    },
                    {
                        src:course,
                        head:"Reseaching and Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    },
                    {
                        src:course,
                        head:"Teaching Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    },
                    {
                        src:course,
                        head:"Reseaching and Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    }
                ]
            }
        ]
    },
    {
        src:course,
        topic:"NET & SET 2",
        full_course:[
            {
                src:course,
                name:"NET & SET 2.1",
                price:3999,
                topic:[
                    {
                        src:course,
                        head:"Teaching Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    },
                    {
                        src:course,
                        head:"Reseaching and Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    },
                    {
                        src:course,
                        head:"Teaching Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    },
                    {
                        src:course,
                        head:"Reseaching and Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    },
                    {
                        src:course,
                        head:"Teaching Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    },
                    {
                        src:course,
                        head:"Reseaching and Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    }
                ]
            },
            {
                src:course,
                name:"NET & SET 2.2",
                price:3999,
                topic:[
                    {
                        src:course,
                        head:"Teaching Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    },
                    {
                        src:course,
                        head:"Reseaching and Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    },
                    {
                        src:course,
                        head:"Teaching Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    },
                    {
                        src:course,
                        head:"Reseaching and Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    },
                    {
                        src:course,
                        head:"Teaching Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    },
                    {
                        src:course,
                        head:"Reseaching and Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    }
                ]
            },
            {
                src:course,
                name:"NET & SET 2.3",
                price:3999,
                topic:[
                    {
                        src:course,
                        head:"Teaching Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    },
                    {
                        src:course,
                        head:"Reseaching and Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    },
                    {
                        src:course,
                        head:"Teaching Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    },
                    {
                        src:course,
                        head:"Reseaching and Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    },
                    {
                        src:course,
                        head:"Teaching Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    },
                    {
                        src:course,
                        head:"Reseaching and Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    }
                ]
            },
            {
                src:course,
                name:"NET & SET 2.4",
                price:3999,
                topic:[
                    {
                        src:course,
                        head:"Teaching Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    },
                    {
                        src:course,
                        head:"Reseaching and Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    },
                    {
                        src:course,
                        head:"Teaching Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    },
                    {
                        src:course,
                        head:"Reseaching and Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    },
                    {
                        src:course,
                        head:"Teaching Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    },
                    {
                        src:course,
                        head:"Reseaching and Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    }
                ]
            },
            {
                src:course,
                name:"NET & SET 2.5",
                price:3999,
                topic:[
                    {
                        src:course,
                        head:"Teaching Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    },
                    {
                        src:course,
                        head:"Reseaching and Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    },
                    {
                        src:course,
                        head:"Teaching Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    },
                    {
                        src:course,
                        head:"Reseaching and Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    },
                    {
                        src:course,
                        head:"Teaching Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    },
                    {
                        src:course,
                        head:"Reseaching and Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    }
                ]
            }
        ]
    },
    {
        src:course,
        topic:"NET & SET 3",
        full_course:[
            {
                src:course,
                name:"NET & SET 3.1",
                price:3999,
                topic:[
                    {
                        src:course,
                        head:"Teaching Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    },
                    {
                        src:course,
                        head:"Reseaching and Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    },
                    {
                        src:course,
                        head:"Teaching Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    },
                    {
                        src:course,
                        head:"Reseaching and Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    },
                    {
                        src:course,
                        head:"Teaching Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    },
                    {
                        src:course,
                        head:"Reseaching and Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    }
                ]
            },
            {
                src:course,
                name:"NET & SET 3.2",
                price:3999,
                topic:[
                    {
                        src:course,
                        head:"Teaching Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    },
                    {
                        src:course,
                        head:"Reseaching and Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    },
                    {
                        src:course,
                        head:"Teaching Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    },
                    {
                        src:course,
                        head:"Reseaching and Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    },
                    {
                        src:course,
                        head:"Teaching Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    },
                    {
                        src:course,
                        head:"Reseaching and Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    }
                ]
            },
            {
                src:course,
                name:"NET & SET 3.3",
                price:3999,
                topic:[
                    {
                        src:course,
                        head:"Teaching Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    },
                    {
                        src:course,
                        head:"Reseaching and Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    },
                    {
                        src:course,
                        head:"Teaching Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    },
                    {
                        src:course,
                        head:"Reseaching and Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    },
                    {
                        src:course,
                        head:"Teaching Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    },
                    {
                        src:course,
                        head:"Reseaching and Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    }
                ]
            },
            {
                src:course,
                name:"NET & SET 3.4",
                price:3999,
                topic:[
                    {
                        src:course,
                        head:"Teaching Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    },
                    {
                        src:course,
                        head:"Reseaching and Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    },
                    {
                        src:course,
                        head:"Teaching Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    },
                    {
                        src:course,
                        head:"Reseaching and Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    },
                    {
                        src:course,
                        head:"Teaching Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    },
                    {
                        src:course,
                        head:"Reseaching and Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    }
                ]
            },
            {
                src:course,
                name:"NET & SET 3.5",
                price:3999,
                topic:[
                    {
                        src:course,
                        head:"Teaching Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    },
                    {
                        src:course,
                        head:"Reseaching and Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    },
                    {
                        src:course,
                        head:"Teaching Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    },
                    {
                        src:course,
                        head:"Reseaching and Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    },
                    {
                        src:course,
                        head:"Teaching Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    },
                    {
                        src:course,
                        head:"Reseaching and Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    }
                ]
            }
        ]
    },
    {
        src:course,
        topic:"NET & SET 4",
        full_course:[
            {
                src:course,
                name:"NET & SET 4.1",
                price:3999,
                topic:[
                    {
                        src:course,
                        head:"Teaching Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    },
                    {
                        src:course,
                        head:"Reseaching and Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    },
                    {
                        src:course,
                        head:"Teaching Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    },
                    {
                        src:course,
                        head:"Reseaching and Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    },
                    {
                        src:course,
                        head:"Teaching Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    },
                    {
                        src:course,
                        head:"Reseaching and Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    }
                ]
            },
            {
                src:course,
                name:"NET & SET 4.2",
                price:3999,
                topic:[
                    {
                        src:course,
                        head:"Teaching Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    },
                    {
                        src:course,
                        head:"Reseaching and Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    },
                    {
                        src:course,
                        head:"Teaching Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    },
                    {
                        src:course,
                        head:"Reseaching and Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    },
                    {
                        src:course,
                        head:"Teaching Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    },
                    {
                        src:course,
                        head:"Reseaching and Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    }
                ]
            },
            {
                src:course,
                name:"NET & SET 4.3",
                price:3999,
                topic:[
                    {
                        src:course,
                        head:"Teaching Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    },
                    {
                        src:course,
                        head:"Reseaching and Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    },
                    {
                        src:course,
                        head:"Teaching Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    },
                    {
                        src:course,
                        head:"Reseaching and Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    },
                    {
                        src:course,
                        head:"Teaching Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    },
                    {
                        src:course,
                        head:"Reseaching and Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    }
                ]
            },
            {
                src:course,
                name:"NET & SET 4.4",
                price:3999,
                topic:[
                    {
                        src:course,
                        head:"Teaching Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    },
                    {
                        src:course,
                        head:"Reseaching and Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    },
                    {
                        src:course,
                        head:"Teaching Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    },
                    {
                        src:course,
                        head:"Reseaching and Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    },
                    {
                        src:course,
                        head:"Teaching Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    },
                    {
                        src:course,
                        head:"Reseaching and Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    }
                ]
            },
            {
                src:course,
                name:"NET & SET 4.5",
                price:3999,
                topic:[
                    {
                        src:course,
                        head:"Teaching Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    },
                    {
                        src:course,
                        head:"Reseaching and Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    },
                    {
                        src:course,
                        head:"Teaching Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    },
                    {
                        src:course,
                        head:"Reseaching and Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    },
                    {
                        src:course,
                        head:"Teaching Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    },
                    {
                        src:course,
                        head:"Reseaching and Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    }
                ]
            }
        ]
    },
    {
        src:course,
        topic:"NET & SET 5",
        full_course:[
            {
                src:course,
                name:"NET & SET 5.1",
                price:3999,
                topic:[
                    {
                        src:course,
                        head:"Teaching Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    },
                    {
                        src:course,
                        head:"Reseaching and Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    },
                    {
                        src:course,
                        head:"Teaching Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    },
                    {
                        src:course,
                        head:"Reseaching and Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    },
                    {
                        src:course,
                        head:"Teaching Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    },
                    {
                        src:course,
                        head:"Reseaching and Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    }
                ]
            },
            {
                src:course,
                name:"NET & SET 5.2",
                price:3999,
                topic:[
                    {
                        src:course,
                        head:"Teaching Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    },
                    {
                        src:course,
                        head:"Reseaching and Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    },
                    {
                        src:course,
                        head:"Teaching Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    },
                    {
                        src:course,
                        head:"Reseaching and Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    },
                    {
                        src:course,
                        head:"Teaching Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    },
                    {
                        src:course,
                        head:"Reseaching and Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    }
                ]
            },
            {
                src:course,
                name:"NET & SET 5.3",
                price:3999,
                topic:[
                    {
                        src:course,
                        head:"Teaching Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    },
                    {
                        src:course,
                        head:"Reseaching and Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    },
                    {
                        src:course,
                        head:"Teaching Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    },
                    {
                        src:course,
                        head:"Reseaching and Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    },
                    {
                        src:course,
                        head:"Teaching Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    },
                    {
                        src:course,
                        head:"Reseaching and Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    }
                ]
            },
            {
                src:course,
                name:"NET & SET 5.4",
                price:3999,
                topic:[
                    {
                        src:course,
                        head:"Teaching Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    },
                    {
                        src:course,
                        head:"Reseaching and Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    },
                    {
                        src:course,
                        head:"Teaching Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    },
                    {
                        src:course,
                        head:"Reseaching and Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    },
                    {
                        src:course,
                        head:"Teaching Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    },
                    {
                        src:course,
                        head:"Reseaching and Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    }
                ]
            },
            {
                src:course,
                name:"NET & SET 5.5",
                price:3999,
                topic:[
                    {
                        src:course,
                        head:"Teaching Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    },
                    {
                        src:course,
                        head:"Reseaching and Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    },
                    {
                        src:course,
                        head:"Teaching Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    },
                    {
                        src:course,
                        head:"Reseaching and Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    },
                    {
                        src:course,
                        head:"Teaching Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    },
                    {
                        src:course,
                        head:"Reseaching and Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    }
                ]
            }
        ]
    },
    {
        src:course,
        topic:"NET & SET 6",
        full_course:[
            {
                src:course,
                name:"NET & SET 6.1",
                price:3999,
                topic:[
                    {
                        src:course,
                        head:"Teaching Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    },
                    {
                        src:course,
                        head:"Reseaching and Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    },
                    {
                        src:course,
                        head:"Teaching Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    },
                    {
                        src:course,
                        head:"Reseaching and Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    },
                    {
                        src:course,
                        head:"Teaching Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    },
                    {
                        src:course,
                        head:"Reseaching and Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    }
                ]
            },
            {
                src:course,
                name:"NET & SET 6.2",
                price:3999,
                topic:[
                    {
                        src:course,
                        head:"Teaching Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    },
                    {
                        src:course,
                        head:"Reseaching and Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    },
                    {
                        src:course,
                        head:"Teaching Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    },
                    {
                        src:course,
                        head:"Reseaching and Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    },
                    {
                        src:course,
                        head:"Teaching Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    },
                    {
                        src:course,
                        head:"Reseaching and Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    }
                ]
            },
            {
                src:course,
                name:"NET & SET 6.3",
                price:3999,
                topic:[
                    {
                        src:course,
                        head:"Teaching Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    },
                    {
                        src:course,
                        head:"Reseaching and Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    },
                    {
                        src:course,
                        head:"Teaching Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    },
                    {
                        src:course,
                        head:"Reseaching and Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    },
                    {
                        src:course,
                        head:"Teaching Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    },
                    {
                        src:course,
                        head:"Reseaching and Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    }
                ]
            },
            {
                src:course,
                name:"NET & SET 6.4",
                price:3999,
                topic:[
                    {
                        src:course,
                        head:"Teaching Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    },
                    {
                        src:course,
                        head:"Reseaching and Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    },
                    {
                        src:course,
                        head:"Teaching Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    },
                    {
                        src:course,
                        head:"Reseaching and Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    },
                    {
                        src:course,
                        head:"Teaching Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    },
                    {
                        src:course,
                        head:"Reseaching and Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    }
                ]
            },
            {
                src:course,
                name:"NET & SET 6.5",
                price:3999,
                topic:[
                    {
                        src:course,
                        head:"Teaching Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    },
                    {
                        src:course,
                        head:"Reseaching and Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    },
                    {
                        src:course,
                        head:"Teaching Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    },
                    {
                        src:course,
                        head:"Reseaching and Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    },
                    {
                        src:course,
                        head:"Teaching Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    },
                    {
                        src:course,
                        head:"Reseaching and Aptitude",
                        subTopic:[
                            {
                                topic:"Learner's characteristics"
                            },
                            {
                                topic:"A line is a thin shape with only length and no breadth. We can say that the line.We can say that the line"
                            },
                            {
                                topic:"Methods of teaching"
                            },
                            {
                                topic:"Factor affecting teaching"
                            },
                            {
                                topic:"Teaching Support System"
                            },
                            {
                                topic:"Evaluation System"
                            },
                            {
                                topic:"Teacher Aptitude"
                            }
                        ]
                    }
                ]
            }
        ]
    },
]